import mitt, {Emitter} from 'mitt';

/**
 * Base for an extension action.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default abstract class ExtensionAction {
    private static _emitter: Emitter<any> = mitt<any>();

    /**
     * Main action container.
     */
    protected _container: HTMLElement;

    static get emitter(): Emitter<any> {
        return this._emitter;
    }

    protected constructor(container: HTMLElement) {
        this._container = container;

        // Emit events as needed in any concrete class
        //this.emitter.emit('ready', this);
    }

    get container(): HTMLElement {
        return this._container;
    }
}
